import { advancedRuleFPAToXML } from 'src/app/_shared/services/advanced-rule/advanced-rule.xml';
import {
    ActivityCatalogAccounting
} from 'src/app/board/activity/activity-shared/activity-settings/activity-catalog/components/edit/activity-catalog-edit-accounting/activity-catalog-edit-accounting.component';
import {
    CatalogArticlesTypes,
    CatalogFamiliesType,
    CatalogProductsType
} from 'src/app/board/activity/activity-shared/activity-settings/activity-catalog/stores/activity-catalog/activity-catalog.state';
import { TypeActivite } from 'src/app/board/activity/activity.constants';
import {
    ActivityRulesEditSubvention
} from 'src/app/board/activity/components/activity-rules-edit-subvention/activity-rules-subvention';
import { arrayNotEmpty } from 'src/app/utils/array.utils';
import { fileModelToXml, getXmlBoolean, getXmlLine } from 'src/app/utils/soap.utils';
import { constants } from 'src/environments/constants';
import {
    ArrayOfEditerBlocDescriptionModel,
    ArrayOfFichierModel,
    ArrayOfLibTypePjBaseModel,
    ArrayOfPrestationPjArticleModel,
    CadeauAfpaModel,
    CadeauFpaModel,
    ChampEditerChampPersoFpa,
    EditChequierAncv,
    FamilleInformationsBaseModel,
    FormulaireFpaModel,
    FpaVenteEnLigneBaseModel,
    FpaVenteEnLigneWithAcompteModel,
    FraisAnnulationFpaModel,
    GroupesInformationsArticleModel,
    GroupesInformationsFamilleModel,
    GroupesInformationsProduitModel,
    GroupeVenteEnLigneFamProduitModel,
    ImputationComptableEditerImputationFpaCharge,
    ImputationComptableEditerImputationFpaProduit,
    ImputationComptableEditerImputationFpaProduitCharge,
    ImputationComptableEditerImputationFpaTousComptes,
    ImputationComptableEditerImputationFpaVariationValorisation,
    ListeCompteursPointsFpa,
    ListesReglesAfpaModel,
    LocationInformationsArticleModel,
    LocationInformationsFamilleModel,
    LocationInformationsProduitModel,
    LocationVenteEnLigneProduitModel,
    ModalitesReglementFpaModel,
    ModeleRegleAccessibilitePretsEtDonsInput,
    ModeleRegleAfpaEnveloppe,
    ModeleRegleAfpaQuota,
    ModeleRegleQuotaPretsEtDonsInput,
    ModeleSaveReglesAfpadto,
    ParametragePrestationModel,
    ParametrageStockFpaModel,
    ParamGroupesArticleModel,
    ParamGroupesFamilleModel,
    ParamGroupesProduitModel,
    ParamLocationArticleModel,
    ParamLocationFamilleModel,
    ParamLocationProduitModel,
    ParamPrestationArticleModel,
    ParamPrestationFamilleModel,
    ParamPrestationProduitModel,
    ParamPretsEtDonsArticleModel,
    ParamPretsEtDonsFamilleModel,
    ParamPretsEtDonsProduitModel,
    ParamVentesChequesArticleModel,
    ParamVentesChequesFamilleModel,
    ParamVentesChequesProduitModel,
    PrestationFamilleVenteEnLigneModel,
    PrestationInformationsArticleModel,
    PrestationProduitVenteEnLigneModel,
    PrestationRemboursementArticleModel,
    PretsEtDonsImputationComptableModel,
    PretsEtDonsInformationsArticleModel,
    PretsEtDonsInformationsProduitModel,
    PrixArticleModel,
    ProduitInformationBaseModel,
    RegleAfpaModel,
    RessourceDescriptionModel,
    StatusDtoEnum,
    ValeurCriteresAyantsDroitModelInput,
    ValeurCriteresLimiteModelInput,
    VentesChequesInformationsArticleModel,
    VentesChequesInformationsFamilleModel,
    VentesChequesInformationsProduitModel,
    VentesChequesVenteEnLigneArticleModel,
    VentesChequesVenteEnLigneFamilleProduitModel
} from 'src/graphql/generated-types';

export function catalogFamilyToXML(family: CatalogFamiliesType, activityTypeCode: string): string {
    switch (activityTypeCode) {
        case TypeActivite.Vente:
        case TypeActivite.ChequesEtBons:
            return catalogSalesFamilyToXML(family as ParamVentesChequesFamilleModel);
        case TypeActivite.Prestation:
            return catalogPrestationFamilyToXML(family as ParamPrestationFamilleModel);
        case TypeActivite.Groupe:
            return catalogGroupsFamilyToXML(family as ParamGroupesFamilleModel);
        case TypeActivite.Location:
            return catalogRentalsFamilyToXML(family as ParamLocationFamilleModel);
        case TypeActivite.Pret:
            return catalogLoansFamilyToXML(family as ParamPretsEtDonsFamilleModel);
    }
}

function catalogSalesFamilyToXML(family: ParamVentesChequesFamilleModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        FamilleInformationsModel,
        FamilleVenteEnLigneModel,
        ImputationComptable,
    } = family;

    return `
        <modeleFamille
          i:type="d4p1:ParamVentesChequesFamilleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Vente}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(family, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogFamilyInformationToXML(FamilleInformationsModel)}
            ${catalogSalesToXML(FamilleVenteEnLigneModel, 'FamilleVenteEnLigneModel')}
            ${catalogAccountingToXML(ImputationComptable as ActivityCatalogAccounting)}
        </modeleFamille>
    `;
}

export function catalogPrestationFamilyToXML(family: ParamPrestationFamilleModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        FamilleInformationsModel,
        FamilleVenteEnLigneModel,
        ImputationComptable,
    } = family;

    return `
        <modeleFamille
          i:type="d4p1:ParamPrestationFamilleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Prestation}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(family, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogBaseFamilyInformationToXML(FamilleInformationsModel)}
            ${catalogOnlineSalesToXML(FamilleVenteEnLigneModel, 'FamilleVenteEnLigneModel')}
            ${catalogBenefitsAccountingToXML(ImputationComptable as ImputationComptableEditerImputationFpaCharge)}
        </modeleFamille>
    `;
}

export function catalogGroupsFamilyToXML(family: ParamGroupesFamilleModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        FamilleInformationsModel,
        FamilleVenteEnLigneModel,
        ImputationComptable,
        ModalitesReglement,
        FraisAnnulation,
    } = family;

    return `
        <modeleFamille
          i:type="d4p1:ParamGroupesFamilleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Groupe}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(family, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogGroupsFamilyInformationToXML(FamilleInformationsModel)}
            ${catalogGroupsSalesToXML(FamilleVenteEnLigneModel, 'FamilleVenteEnLigneModel')}
            ${catalogCancellationFeesToXML(FraisAnnulation)}
            ${catalogAccountingToXML(ImputationComptable as ActivityCatalogAccounting)}
            ${catalogPaymentsToXML(ModalitesReglement)}
        </modeleFamille>
    `;
}

export function catalogRentalsFamilyToXML(family: ParamLocationFamilleModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        FamilleInformationsModel,
        FamilleVenteEnLigneModel,
        ImputationComptable,
        ModalitesReglement,
        FraisAnnulation,
    } = family;

    return `
        <modeleFamille
          i:type="d4p1:ParamLocationFamilleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Location}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(family, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogRentalsFamilyInformationToXML(FamilleInformationsModel)}
            ${catalogRentalsSalesToXML(FamilleVenteEnLigneModel, 'FamilleVenteEnLigneModel')}
            ${catalogCancellationFeesToXML(FraisAnnulation)}
            ${catalogAccountingToXML(ImputationComptable as ActivityCatalogAccounting)}
            ${catalogPaymentsToXML(ModalitesReglement)}
        </modeleFamille>
    `;
}

export function catalogLoansFamilyToXML(family: ParamPretsEtDonsFamilleModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        Regles,
        ModeleFormulaireFPA,
        FamilleInformationsModel,
        FamilleImputationComptableModel,
        ModeleSaveReglesAFPA,
    } = family;

    return `
        <modeleFamille
          i:type="d4p1:ParamPretsEtDonsFamilleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Pret}</d4p1:CodeTypeActivite>
            <d4p1:IdElement>${FamilleInformationsModel?.IdFamille || 0}</d4p1:IdElement>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlBoolean(family, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogLoansAccountingToXML(FamilleImputationComptableModel, 'FamilleImputationComptableModel')}
            ${catalogBaseFamilyInformationToXML(FamilleInformationsModel)}
            ${catalogRulesModelToXml(ModeleSaveReglesAFPA)}

        </modeleFamille>
    `;
}

export function catalogProductToXML(produit: CatalogProductsType, activityTypeCode: string): string {
    switch (activityTypeCode) {
        case TypeActivite.Vente:
        case TypeActivite.ChequesEtBons:
            return catalogSalesProductToXML(produit as ParamVentesChequesProduitModel, activityTypeCode);
        case TypeActivite.Prestation:
            return catalogBenefitsProductToXML(produit as ParamPrestationProduitModel);
        case TypeActivite.Groupe:
            return catalogGroupProductToXML(produit as ParamGroupesProduitModel);
        case TypeActivite.Location:
            return catalogRentalsProductToXML(produit as ParamLocationProduitModel);
        case TypeActivite.Pret:
            return catalogLoansProductToXML(produit as ParamPretsEtDonsProduitModel);
    }
}

export function catalogSalesProductToXML(product: ParamVentesChequesProduitModel, activityTypeCode: string): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        GestionStock,
        ProduitInformationsModel,
        ProduitVenteEnLigneModel,
        ImputationComptable,
    } = product;

    return `
        <modeleProduit
          i:type="d4p1:ParamVentesChequesProduitModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${activityTypeCode}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(product, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogStockMangagementToXML(GestionStock)}
            ${catalogAccountingToXML(ImputationComptable as ActivityCatalogAccounting)}
            ${catalogProductInformationsToXML(ProduitInformationsModel)}
            ${catalogSalesToXML(ProduitVenteEnLigneModel, 'ProduitVenteEnLigneModel')}
        </modeleProduit>
    `;
}

export function catalogBenefitsProductToXML(product: ParamPrestationProduitModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        ProduitInformationsModel,
        ProduitVenteEnLigneModel,
        ImputationComptable,
        ParametragePrestation,
        Cadeau
    } = product;

    return `
        <modeleProduit
          i:type="d4p1:ParamPrestationProduitModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:d5p1="http://schemas.datacontract.org/2004/07/V2DTO.Champ"
          xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Prestation}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(product, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogGiftToXML(Cadeau)}
            ${catalogBenefitsProductAccountingToXML(ImputationComptable, ParametragePrestation)}
            ${catalogBenefitsSettingsToXML(ParametragePrestation)}
            ${catalogBaseProductInformationToXML(ProduitInformationsModel)}
            ${catalogBenefitsProductSalesToXML(ProduitVenteEnLigneModel)}
        </modeleProduit>
    `;
}

export function catalogGroupProductToXML(product: ParamGroupesProduitModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ListeBlocDescription,
        ListeDocuments,
        ModeleFormulaireFPA,
        Regles,
        FraisAnnulation,
        ProduitInformationsModel,
        ProduitVenteEnLigneModel,
        ImputationComptable,
        ModalitesReglement
    } = product;

    return `
        <modeleProduit
          i:type="d4p1:ParamGroupesProduitModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Groupe}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(product, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles, TypeActivite.Groupe)}
            ${catalogCancellationFeesToXML(FraisAnnulation)}
            ${catalogAccountingToXML(ImputationComptable as ActivityCatalogAccounting)}
            ${catalogCancellationFeesToXML(FraisAnnulation)}
            ${catalogDescriptionsToXML(ListeBlocDescription)}
            ${catalogDocumentsToXML(ListeDocuments)}
            ${catalogPaymentsToXML(ModalitesReglement)}
            ${catalogProductGroupsInformationToXML(ProduitInformationsModel)}
            ${catalogGroupsSalesToXML(ProduitVenteEnLigneModel, 'ProduitVenteEnLigneModel')}
        </modeleProduit>
    `;
}

export function catalogRentalsProductToXML(product: ParamLocationProduitModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ListeBlocDescription,
        ListeDocuments,
        ModeleFormulaireFPA,
        Regles,
        FraisAnnulation,
        ProduitInformationsModel,
        ProduitVenteEnLigneModel,
        ImputationComptable,
        ModalitesReglement
    } = product;

    return `
        <modeleProduit
          i:type="d4p1:ParamLocationProduitModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Location}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(product, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogCancellationFeesToXML(FraisAnnulation)}
            ${catalogAccountingToXML(ImputationComptable as ActivityCatalogAccounting)}
            ${catalogCancellationFeesToXML(FraisAnnulation)}
            ${catalogDescriptionsToXML(ListeBlocDescription)}
            ${catalogDocumentsToXML(ListeDocuments)}
            ${catalogPaymentsToXML(ModalitesReglement)}
            ${catalogProductRentalsInformationToXML(ProduitInformationsModel)}
            ${catalogRentalsSalesToXML(ProduitVenteEnLigneModel, 'ProduitVenteEnLigneModel')}
        </modeleProduit>
    `;
}

export function catalogLoansProductToXML(product: ParamPretsEtDonsProduitModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        ProduitInformationsModel,
        ModeleSaveReglesAFPA,
        ProduitImputationComptableModel,
        ProduitDescriptionModel
    } = product;

    return `
        <modeleProduit
          i:type="d4p1:ParamPretsEtDonsProduitModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Pret}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(product, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogRulesModelToXml(ModeleSaveReglesAFPA)}
            ${sharedResourceDescriptionToXML(ProduitDescriptionModel, 'ProduitDescriptionModel')}
            ${catalogLoansAccountingToXML(ProduitImputationComptableModel, 'ProduitImputationComptableModel')}
            ${catalogLoansProductInformationToXML(ProduitInformationsModel)}
        </modeleProduit>
    `;
}

export function catalogArticleToXML(article: CatalogArticlesTypes, activityTypeCode: string): string {
    switch (activityTypeCode) {
        case TypeActivite.Vente:
        case TypeActivite.ChequesEtBons:
            return catalogSalesArticleToXML(article, activityTypeCode);
        case TypeActivite.Prestation:
            return catalogBenefitsArticleToXML(article);
        case TypeActivite.Groupe:
            return catalogGroupsArticleToXML(article);
        case TypeActivite.Location:
            return catalogRentalsArticleToXML(article);
        case TypeActivite.Pret:
            return catalogLoansArticleToXML(article);
    }
}

export function catalogSalesArticleToXML(article: ParamVentesChequesArticleModel, activityTypeCode: string): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        ArticleInformationsModel,
        ArticleVenteEnLigneModel,
        ImputationComptable,
        PrixArticle,
        ChequierANCV,
    } = article;

    return `
        <modeleArticle
          i:type="d4p1:ParamVentesChequesArticleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${activityTypeCode}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(article, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogSalesArticleInformationToXML(ArticleInformationsModel)}
            ${catalogSalesToXML(ArticleVenteEnLigneModel, 'ArticleVenteEnLigneModel')}
            ${catalogArticleANCVCouponsToXML(ChequierANCV, {isChequierDynamique: !!ArticleInformationsModel?.IsChequierDynamique})}
            ${catalogAccountingToXML(ImputationComptable as ActivityCatalogAccounting)}
            ${catalogArticlePriceToXML(PrixArticle)}
        </modeleArticle>
    `;
}

export function catalogBenefitsArticleToXML(article: ParamPrestationArticleModel & { IsProduitRemboursement }): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        ArticleInformationsModel,
        ArticleVenteEnLigneModel,
        ImputationComptable,
        ArticleRemboursementModel,
        ListePieceJustificativeModel,
        IsProduitRemboursement,
        Cadeau,
    } = article;

    return `
        <modeleArticle
          i:type="d4p1:ParamPrestationArticleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Prestation}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(article, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles, TypeActivite.Prestation)}
            ${catalogBenefitsArticleInformationToXML({
        ...ArticleInformationsModel,
        Quotite: ArticleRemboursementModel?.Quotite || 1
    })}
            ${catalogBenefitsRefundToXML(ArticleRemboursementModel)}
            ${catalogOnlineSalesToXML(ArticleVenteEnLigneModel, 'ArticleVenteEnLigneModel')}
            ${catalogGiftToXML(Cadeau)}
            ${catalogBenefitsProductAccountingToXML(ImputationComptable as AccountingTypes, {
        IsRemboursement: IsProduitRemboursement,
    })}
            ${catalogBenefitsVouchersToXML(ListePieceJustificativeModel)}
        </modeleArticle>
    `;
}

function catalogGroupsArticleToXML(article: ParamGroupesArticleModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        ArticleInformationsModel,
        ArticleVenteEnLigneModel,
        ImputationComptable,
        PrixArticle,
        FraisAnnulation
    } = article;

    return `
        <modeleArticle
          i:type="d4p1:ParamGroupesArticleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Groupe}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(article, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogGroupsArticleInformationToXML(ArticleInformationsModel)}
            ${catalogOnlineSalesToXML(ArticleVenteEnLigneModel, 'ArticleVenteEnLigneModel')}
            ${catalogCancellationFeesToXML(FraisAnnulation)}
            ${catalogAccountingToXML(ImputationComptable as ActivityCatalogAccounting)}
            ${catalogArticlePriceToXML(PrixArticle)}
        </modeleArticle>
    `;
}

function catalogRentalsArticleToXML(article: ParamLocationArticleModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        ArticleInformationsModel,
        ArticleVenteEnLigneModel,
        ImputationComptable,
        PrixArticle,
        FraisAnnulation
    } = article;

    return `
        <modeleArticle
          i:type="d4p1:ParamLocationArticleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Location}</d4p1:CodeTypeActivite>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(article, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogRentalsArticleInformationToXML(ArticleInformationsModel)}
            ${catalogOnlineSalesToXML(ArticleVenteEnLigneModel, 'ArticleVenteEnLigneModel')}
            ${catalogCancellationFeesToXML(FraisAnnulation)}
            ${catalogAccountingToXML(ImputationComptable as ActivityCatalogAccounting)}
            ${catalogArticlePriceToXML(PrixArticle)}
        </modeleArticle>
    `;
}

function catalogLoansArticleToXML(article: ParamPretsEtDonsArticleModel): string {
    const {
        Illustration,
        CompteursDePoints,
        ListeChampsPersonnalises,
        ModeleFormulaireFPA,
        Regles,
        ArticleInformationsModel,
        ArticleImputationComptableModel,
        ListePieceJustificativeModel,
        ModeleSaveReglesAFPA
    } = article;

    return `
        <modeleArticle
          i:type="d4p1:ParamPretsEtDonsArticleModel"
          xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:CodeTypeActivite>${TypeActivite.Pret}</d4p1:CodeTypeActivite>
            <d4p1:IdElement>${ArticleImputationComptableModel?.IdElement || 0}</d4p1:IdElement>
            ${!!Illustration ? fileModelToXml(Illustration, 'Illustration') : ''}
            ${getXmlLine(article, 'RedescendreImage')}
            ${catalogPointCounterToXML(CompteursDePoints)}
            ${catalogCustomFieldsToXML(ListeChampsPersonnalises?.ChampEditerChampPersoFPA)}
            ${catalogFormsToXML(ModeleFormulaireFPA)}
            ${catalogRulesToXML(Regles)}
            ${catalogLoansAccountingToXML(ArticleImputationComptableModel, 'ArticleImputationComptableModel')}
            ${catalogLoansArticleInformationToXML(ArticleInformationsModel)}
            ${catalogLoansVouchersToXML(ListePieceJustificativeModel)}
            ${catalogRulesModelToXml(ModeleSaveReglesAFPA)}
        </modeleArticle>
    `;
}

export function catalogFamilyInformationToXML(informations: VentesChequesInformationsFamilleModel): string {
    return `
    <d4p1:FamilleInformationsModel>
        ${getXmlLine(informations, 'CodeFamille', {defaultValue: ''})}
        ${getXmlLine(informations, 'Description')}
        ${getXmlLine(informations, 'IdActivite')}
        ${getXmlLine(informations, 'IdDelegation')}
        ${getXmlLine(informations, 'IdEnveloppe', {defaultValue: 0})}
        ${getXmlLine(informations, 'IdFamille', {defaultValue: 0})}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlBoolean(informations, 'IsFacturationManuelle')}
        ${getXmlLine(informations, 'LibelleFamille', {defaultValue: ''})}
        ${getXmlLine(informations, 'MontantAcompteEuro')}
        ${getXmlLine(informations, 'MontantAcomptePourcentage')}
        ${getXmlBoolean(informations, 'NeedAcceptationCE')}
        ${getXmlBoolean(informations, 'RedescendreAcceptation')}
        ${getXmlBoolean(informations, 'RedescendreParametrageAcompte')}
        ${getXmlLine(informations, 'Remarque')}
    </d4p1:FamilleInformationsModel>
    `;
}

export function catalogGroupsFamilyInformationToXML(informations: GroupesInformationsFamilleModel): string {
    return `
    <d4p1:FamilleInformationsModel>
        ${getXmlLine(informations, 'CodeFamille', {defaultValue: ''})}
        ${getXmlLine(informations, 'Description')}
        ${getXmlLine(informations, 'IdActivite')}
        ${getXmlLine(informations, 'IdCourrierAcceptation')}
        ${getXmlLine(informations, 'IdCourrierRefus')}
        ${getXmlLine(informations, 'IdDelegation')}
        ${getXmlLine(informations, 'IdEnveloppe', {defaultValue: 0})}
        ${getXmlLine(informations, 'IdFamille', {defaultValue: 0})}
        ${getXmlLine(informations, 'IdSessionChoix')}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlBoolean(informations, 'IsFacturationManuelle')}
        ${getXmlLine(informations, 'LibelleFamille', {defaultValue: ''})}
        ${getXmlLine(informations, 'MontantAcompteEuro')}
        ${getXmlLine(informations, 'MontantAcomptePourcentage')}
        ${getXmlBoolean(informations, 'NeedAcceptationCE')}
        ${getXmlBoolean(informations, 'RedescendreAcceptation')}
        ${getXmlBoolean(informations, 'RedescendreParametrageAcompte')}
        ${getXmlLine(informations, 'Remarque')}
    </d4p1:FamilleInformationsModel>
    `;
}

export function catalogRentalsFamilyInformationToXML(informations: LocationInformationsFamilleModel): string {
    return `
    <d4p1:FamilleInformationsModel>
        ${getXmlLine(informations, 'CodeFamille', {defaultValue: ''})}
        ${getXmlLine(informations, 'Description')}
        ${getXmlLine(informations, 'IdActivite')}
        ${getXmlLine(informations, 'IdCourrierAcceptation')}
        ${getXmlLine(informations, 'IdCourrierRefus')}
        ${getXmlLine(informations, 'IdDelegation')}
        ${getXmlLine(informations, 'IdEnveloppe', {defaultValue: 0})}
        ${getXmlLine(informations, 'IdFamille', {defaultValue: 0})}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlBoolean(informations, 'IsFacturationManuelle')}
        ${getXmlLine(informations, 'LibelleFamille', {defaultValue: ''})}
        ${getXmlLine(informations, 'MontantAcompteEuro')}
        ${getXmlLine(informations, 'MontantAcomptePourcentage')}
        ${getXmlBoolean(informations, 'NeedAcceptationCE')}
        ${getXmlBoolean(informations, 'NotProposerLocNonDispo', {defaultValue: true})}
        ${getXmlBoolean(informations, 'RedescendreAcceptation')}
        ${getXmlBoolean(informations, 'RedescendreParametrageAcompte')}
        ${getXmlLine(informations, 'Remarque')}
    </d4p1:FamilleInformationsModel>
    `;
}

export function catalogProductGroupsInformationToXML(informations: GroupesInformationsProduitModel): string {
    return `
    <d4p1:ProduitInformationsModel>
        ${getXmlLine(informations, 'CodeProduit', {defaultValue: ''})}
        ${getXmlLine(informations, 'DateDebutEvenement')}
        ${getXmlLine(informations, 'DateFinEvenement')}
        ${getXmlLine(informations, 'DatePriseEnCompteSub')}
        ${getXmlLine(informations, 'DescriptionProduit')}
        ${getXmlLine(informations, 'IdAnneeReference')}
        ${getXmlLine(informations, 'IdCourrierAcceptation')}
        ${getXmlLine(informations, 'IdCourrierRefus')}
        ${getXmlLine(informations, 'IdEnveloppe', {defaultValue: 0})}
        ${getXmlLine(informations, 'IdFamille')}
        ${getXmlLine(informations, 'IdProduit', {defaultValue: 0})}
        ${getXmlLine(informations, 'IdSessionChoix')}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlBoolean(informations, 'IsFacturationCentralisee', {defaultValue: false})}
        ${getXmlBoolean(informations, 'IsFacturationManuelle')}
        ${getXmlLine(informations, 'LibelleProduit', {defaultValue: ''})}
        ${getXmlLine(informations, 'MontantAcompteEuro')}
        ${getXmlLine(informations, 'MontantAcomptePourcentage')}
        ${getXmlLine(informations, 'NbPlacesDispo')}
        ${getXmlBoolean(informations, 'NeedAcceptationCE')}
        ${getXmlBoolean(informations, 'RedescendreAcceptation')}
        ${getXmlBoolean(informations, 'RedescendreParametrageAcompte')}
        ${getXmlLine(informations, 'RemarqueProduit')}
    </d4p1:ProduitInformationsModel>
    `;
}

export function catalogProductRentalsInformationToXML(informations: LocationInformationsProduitModel): string {
    return `
    <d4p1:ProduitInformationsModel>
        ${getXmlBoolean(informations, 'AutoriserReservationsSupp', {defaultValue: false})}
        ${getXmlLine(informations, 'CapaciteMaxi')}
        ${getXmlLine(informations, 'CapaciteMini')}
        ${getXmlLine(informations, 'CodeProduit', {defaultValue: ''})}
        ${getXmlLine(informations, 'DateDebutLocation')}
        ${getXmlLine(informations, 'DateFinLocation')}
        ${getXmlLine(informations, 'DatePriseEnCompteSub')}
        ${getXmlLine(informations, 'DescriptionProduit')}
        ${getXmlLine(informations, 'IdAnneeReference')}
        ${getXmlLine(informations, 'IdCourrierAcceptation')}
        ${getXmlLine(informations, 'IdCourrierRefus')}
        ${getXmlLine(informations, 'IdEnveloppe', {defaultValue: 0})}
        ${getXmlLine(informations, 'IdFamille')}
        ${getXmlLine(informations, 'IdProduit', {defaultValue: 0})}
        ${getXmlLine(informations, 'IdSessionChoix')}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlBoolean(informations, 'IsFacturationManuelle', {defaultValue: false})}
        ${getXmlBoolean(informations, 'IsGestionAllotement', {defaultValue: false})}
        ${getXmlBoolean(informations, 'IsGestionParticipant', {defaultValue: false})}
        ${getXmlBoolean(informations, 'IsProduitCommandeSeul', {defaultValue: false})}
        ${getXmlLine(informations, 'LibelleProduit', {defaultValue: ''})}
        ${getXmlLine(informations, 'MontantAcompteEuro')}
        ${getXmlLine(informations, 'MontantAcomptePourcentage')}
        ${getXmlBoolean(informations, 'NeedAcceptationCE')}
        ${getXmlBoolean(informations, 'NotProposerLocNonDispo', {defaultValue: true})}
        ${getXmlBoolean(informations, 'RedescendreAcceptation')}
        ${getXmlBoolean(informations, 'RedescendreParametrageAcompte')}
        ${getXmlLine(informations, 'RemarqueProduit')}
    </d4p1:ProduitInformationsModel>
    `;
}

export function catalogBaseFamilyInformationToXML(informations: FamilleInformationsBaseModel): string {
    return `
<d4p1:FamilleInformationsModel>
    ${getXmlLine(informations, 'CodeFamille', {defaultValue: ''})}
    ${getXmlLine(informations, 'Description')}
    ${getXmlLine(informations, 'IdActivite')}
    ${getXmlLine(informations, 'IdDelegation')}
    ${getXmlLine(informations, 'IdEnveloppe')}
    ${getXmlLine(informations, 'IdFamille', {defaultValue: 0})}
    ${getXmlBoolean(informations, 'IsCloture')}
    ${getXmlLine(informations, 'LibelleFamille', {defaultValue: ''})}
    ${getXmlLine(informations, 'Remarque')}
</d4p1:FamilleInformationsModel>
    `;
}

export function catalogProductInformationsToXML(informations: VentesChequesInformationsProduitModel): string {
    return `
        <d4p1:ProduitInformationsModel>
            ${getXmlLine(informations, 'CodeProduit', {defaultValue: ''})}
            ${getXmlLine(informations, 'DatePriseEnCompteSub')}
            ${getXmlLine(informations, 'DescriptionProduit', {defaultValue: ''})}
            ${getXmlLine(informations, 'IdEnveloppe')}
            ${getXmlLine(informations, 'IdFamille')}
            ${getXmlLine(informations, 'IdProduit', {defaultValue: 0})}
            ${getXmlBoolean(informations, 'IsCloture')}
            ${getXmlBoolean(informations, 'IsFacturationManuelle')}
            ${getXmlBoolean(informations, 'IsProduitCommandeSeul')}
            ${getXmlLine(informations, 'LibelleProduit')}
            ${getXmlLine(informations, 'MontantAcompteEuro')}
            ${getXmlLine(informations, 'MontantAcomptePourcentage')}
            ${getXmlBoolean(informations, 'NeedAcceptationCE')}
            ${getXmlBoolean(informations, 'RedescendreAcceptation')}
            ${getXmlLine(informations, 'RemarqueProduit', {defaultValue: ''})}
        </d4p1:ProduitInformationsModel>
    `;
}

export function catalogBaseProductInformationToXML(informations: ProduitInformationBaseModel): string {
    return `
        <d4p1:ProduitInformationsModel>
            ${getXmlLine(informations, 'CodeProduit', {defaultValue: ''})}
            ${getXmlLine(informations, 'DescriptionProduit')}
            ${getXmlLine(informations, 'IdEnveloppe')}
            ${getXmlLine(informations, 'IdActivite')}
            ${getXmlLine(informations, 'IdFamille')}
            ${getXmlLine(informations, 'IdDelegation')}
            ${getXmlLine(informations, 'IdProduit', {defaultValue: 0})}
            ${getXmlLine(informations, 'LibelleProduit', {defaultValue: ''})}
            ${getXmlLine(informations, 'RemarqueProduit')}
        </d4p1:ProduitInformationsModel>
    `;
}

export function catalogLoansProductInformationToXML(informations: PretsEtDonsInformationsProduitModel): string {
    return `
        <d4p1:ProduitInformationsModel>
            ${getXmlLine(informations, 'CodeProduit', {defaultValue: ''})}
            ${getXmlLine(informations, 'CodeTypeMoyenPaiementRemboursementBenefPret')}
            ${getXmlLine(informations, 'DescriptionProduit')}
            ${getXmlLine(informations, 'IdEnveloppe')}
            ${getXmlLine(informations, 'IdActivite')}
            ${getXmlLine(informations, 'IdFamille')}
            ${getXmlLine(informations, 'IdDelegation')}
            ${getXmlLine(informations, 'IdProduit', {defaultValue: 0})}
            ${getXmlBoolean(informations, 'IsCloture')}
            ${getXmlBoolean(informations, 'IsTypeProduitBlocked')}
            ${getXmlBoolean(informations, 'IsTypeProduitPret',)}
            ${getXmlLine(informations, 'LibelleProduit', {defaultValue: ''})}
            ${getXmlLine(informations, 'RemarqueProduit')}
        </d4p1:ProduitInformationsModel>
    `;
}

export function catalogSalesArticleInformationToXML(informations: VentesChequesInformationsArticleModel): string {
    return `
    <d4p1:ArticleInformationsModel>
        ${getXmlLine(informations, 'CodeArticle', {defaultValue: ''})}
        ${getXmlLine(informations, 'CodeBarre', {defaultValue: ''})}
        ${getXmlLine(informations, 'DatePriseEnCompteSub')}
        ${getXmlLine(informations, 'Description', {defaultValue: ''})}
        ${getXmlLine(informations, 'IdArticle')}
        ${getXmlLine(informations, 'IdEnveloppe')}
        ${getXmlLine(informations, 'IdProduit')}
        ${getXmlBoolean(informations, 'IsANCVConnect', {defaultValue: false})}
        ${getXmlBoolean(informations, 'IsChequierDynamique', {defaultValue: false})}
        ${getXmlBoolean(informations, 'IsChequierDynamiqueConnect', {defaultValue: false})}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlBoolean(informations, 'IsECesu', {defaultValue: false})}
        ${getXmlBoolean(informations, 'IsGenerique')}
        ${getXmlLine(informations, 'Libelle', {defaultValue: ''})}
        ${getXmlLine(informations, 'QteStockMiniPourAlerte')}
        ${getXmlLine(informations, 'Quotite')}
        ${getXmlLine(informations, 'RemarqueArticle', {defaultValue: ''})}
    </d4p1:ArticleInformationsModel>
    `;
}

export function catalogBenefitsArticleInformationToXML(informations: PrestationInformationsArticleModel): string {
    return `
    <d4p1:ArticleInformationsModel>
        ${getXmlLine(informations, 'CodeArticle', {defaultValue: ''})}
        ${getXmlLine(informations, 'CodeBarre', {defaultValue: ''})}
        ${informations.IsPrestationCadeau ? getXmlLine(informations, 'DateEvenement') : ''}
        ${getXmlLine(informations, 'Description', {defaultValue: ''})}
        ${getXmlLine(informations, 'IdArticle')}
        ${getXmlLine(informations, 'IdEnveloppe')}
        ${getXmlLine(informations, 'IdProduit')}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlBoolean(informations, 'IsPrestationCadeau')}
        ${getXmlLine(informations, 'Libelle', {defaultValue: ''})}
        ${informations.IsPrestationCadeau ? getXmlLine(informations, 'LibelleDateEvenement', {defaultValue: ''}) : ''}
        ${getXmlLine(informations, 'QteStockMiniPourAlerte')}
        ${getXmlLine(informations, 'Quotite')}
        ${getXmlLine(informations, 'RemarqueArticle', {defaultValue: ''})}
    </d4p1:ArticleInformationsModel>
    `;
}

export function catalogGroupsArticleInformationToXML(informations: GroupesInformationsArticleModel): string {
    return `
    <d4p1:ArticleInformationsModel>
        ${getXmlLine(informations, 'CodeArticle', {defaultValue: ''})}
        ${getXmlLine(informations, 'CodeBarre', {defaultValue: ''})}
        ${getXmlLine(informations, 'DatePriseEnCompteSub')}
        ${getXmlLine(informations, 'Description', {defaultValue: ''})}
        ${getXmlLine(informations, 'IdArticle')}
        ${getXmlLine(informations, 'IdDelegation')}
        ${getXmlLine(informations, 'IdEnveloppe')}
        ${getXmlLine(informations, 'IdProduit')}
        ${getXmlBoolean(informations, 'IsArticleNominatif')}
        ${getXmlBoolean(informations, 'IsArticleOption')}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlLine(informations, 'Libelle', {defaultValue: ''})}
        ${getXmlLine(informations, 'NbPlacesDispos')}
        ${getXmlLine(informations, 'Quotite')}
        ${getXmlLine(informations, 'RemarqueArticle', {defaultValue: ''})}
    </d4p1:ArticleInformationsModel>
    `;
}

export function catalogRentalsArticleInformationToXML(informations: LocationInformationsArticleModel): string {
    return `
    <d4p1:ArticleInformationsModel>
        ${getXmlLine(informations, 'CodeArticle', {defaultValue: ''})}
        ${getXmlLine(informations, 'CodeBarre', {defaultValue: ''})}
        ${getXmlLine(informations, 'DateDebutLocation')}
        ${getXmlLine(informations, 'DateFinLocation')}
        ${getXmlLine(informations, 'DateLimiteDispo')}
        ${getXmlLine(informations, 'DatePriseEnCompteSub')}
        ${getXmlBoolean(informations, 'DepassementDateAutorise')}
        ${getXmlLine(informations, 'Description', {defaultValue: ''})}
        ${getXmlLine(informations, 'IdAnneeReference')}
        ${getXmlLine(informations, 'IdArticle')}
        ${getXmlLine(informations, 'IdDelegation')}
        ${getXmlLine(informations, 'IdEnveloppe')}
        ${getXmlLine(informations, 'IdProduit')}
        ${getXmlLine(informations, 'IdSessionChoix')}
        ${getXmlBoolean(informations, 'IsArticleCommandeSeul')}
        ${getXmlBoolean(informations, 'IsArticleOption')}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlBoolean(informations, 'IsObligatoire')}
        ${getXmlBoolean(informations, 'IsProduitAllotement')}
        ${getXmlBoolean(informations, 'IsUsedOnLigneCommande')}
        ${getXmlLine(informations, 'Libelle', {defaultValue: ''})}
        ${getXmlLine(informations, 'NbArticleDispo')}
        ${getXmlLine(informations, 'Quotite')}
        ${getXmlLine(informations, 'RemarqueArticle', {defaultValue: ''})}
    </d4p1:ArticleInformationsModel>
    `;
}

export function catalogLoansArticleInformationToXML(informations: PretsEtDonsInformationsArticleModel): string {
    return `
    <d4p1:ArticleInformationsModel>
   <!-- <d4p1:Status>INSERTED</d4p1:Status> -->
        ${getXmlLine(informations, 'CodeArticle', {defaultValue: ''})}
        ${getXmlLine(informations, 'DureeMaximunArticle')}
        ${getXmlLine(informations, 'DureeMinimunOrFixeArticle')}
        ${getXmlLine(informations, 'IdArticle')}
        ${getXmlLine(informations, 'IdDelegation')}
        ${getXmlLine(informations, 'IdEnveloppe')}
        ${getXmlLine(informations, 'IdProduit')}
        ${getXmlBoolean(informations, 'IsCloture')}
        ${getXmlBoolean(informations, 'IsDureeFixeArticle')}
        ${getXmlBoolean(informations, 'IsMontantFixeArticle')}
        ${getXmlBoolean(informations, 'IsTypeProduitPret')}
        ${getXmlLine(informations, 'LibelleArticle')}
        ${getXmlLine(informations, 'MontantMaximunArticle')}
        ${getXmlLine(informations, 'MontantMinimunOrFixeArticle')}
        ${getXmlLine(informations, 'PourcentageFraisDossierArticle')}
        ${getXmlLine(informations, 'Quotite')}
        ${getXmlLine(informations, 'RemarqueArticle', {defaultValue: ''})}
    </d4p1:ArticleInformationsModel>
    `;
}

export function catalogFormsToXML(forms: FormulaireFpaModel): string {
    return `
    <d4p1:ModeleFormulaireFPA>
        ${getXmlLine(forms, 'IdFormulaireCommande')}
        ${getXmlLine(forms, 'IdFormulaireLigne')}
        ${getXmlBoolean(forms, 'IsArticleUnitaire')}
        ${getXmlBoolean(forms, 'RedescendreSurEnfants')}
        ${getXmlLine(forms, 'TypeElement')}
    </d4p1:ModeleFormulaireFPA>
    `;
}

export function catalogSalesToXML(onlineSale: VentesChequesVenteEnLigneFamilleProduitModel | VentesChequesVenteEnLigneArticleModel, name: string): string {
    const {ListeModeLivraison, VenteEnLigneModel} = onlineSale;
    return `
        <d4p1:${name}>
        ${arrayNotEmpty(ListeModeLivraison.ModeLivraisonFPAModel) ? `
            <d4p1:ListeModeLivraison>
            ${ListeModeLivraison.ModeLivraisonFPAModel.map(deliveryMode => `
                <d4p1:ModeLivraisonFPAModel>
                    ${getXmlLine(deliveryMode, 'IdModeLivraison')}
                    ${getXmlBoolean(deliveryMode, 'IsDefaut')}
                    ${getXmlBoolean(deliveryMode, 'IsPossible')}
                </d4p1:ModeLivraisonFPAModel>
            `).join('')}
            </d4p1:ListeModeLivraison>
        ` : ''}

            <d4p1:VenteEnLigneModel>
                ${getXmlBoolean(VenteEnLigneModel, 'AutoriserCommandesEnLigne')}
                ${getXmlLine(VenteEnLigneModel, 'DateDebutVisibilite')}
                ${getXmlLine(VenteEnLigneModel, 'DateFinVisibilite')}
                ${getXmlBoolean(VenteEnLigneModel, 'IsAcompteObligatoireEnLigne')}
                ${getXmlBoolean(VenteEnLigneModel, 'IsAfficheEnLigne')}
                ${getXmlBoolean(VenteEnLigneModel, 'RedescendreVenteEnLigne')}
            </d4p1:VenteEnLigneModel>
        </d4p1:${name}>
    `;
}

export function catalogGroupsSalesToXML(onlineSale: GroupeVenteEnLigneFamProduitModel, name: string): string {
    return `
        <d4p1:${name}>
            ${getXmlBoolean(onlineSale, 'AfficherNbInscrits')}
            ${getXmlBoolean(onlineSale, 'AfficherNbPlacesDispo')}
            ${getXmlBoolean(onlineSale, 'AfficherNbPlacesTotales')}
            ${getXmlBoolean(onlineSale, 'AutoriserCommandesEnLigne')}
            ${getXmlLine(onlineSale, 'DateDebutVisibilite')}
            ${getXmlLine(onlineSale, 'DateFinVisibilite')}
            ${getXmlBoolean(onlineSale, 'IsAcompteObligatoireEnLigne')}
            ${getXmlBoolean(onlineSale, 'IsAfficheEnLigne')}
            ${getXmlBoolean(onlineSale, 'RedescendreVenteEnLigne')}
        </d4p1:${name}>
    `;
}

export function catalogRentalsSalesToXML(onlineSale: FpaVenteEnLigneWithAcompteModel | LocationVenteEnLigneProduitModel, name: string): string {
    return `
        <d4p1:${name}>
                ${getXmlBoolean(onlineSale, 'AutoriserCommandesEnLigne')}
                ${getXmlLine(onlineSale, 'DateDebutVisibilite')}
                ${getXmlLine(onlineSale, 'DateFinVisibilite')}
                ${getXmlBoolean(onlineSale, 'IsAcompteObligatoireEnLigne')}
                ${getXmlBoolean(onlineSale, 'IsAfficheEnLigne')}
                ${getXmlLine(onlineSale, 'LibelleDetail')}
                ${getXmlBoolean(onlineSale, 'RedescendreVenteEnLigne')}
        </d4p1:${name}>
    `;
}

export function catalogOnlineSalesToXML(onlineSale: PrestationFamilleVenteEnLigneModel | FpaVenteEnLigneBaseModel, name: string): string {
    return `
        <d4p1:${name}>
            ${getXmlBoolean(onlineSale, 'AutoriserCommandesEnLigne')}
            ${getXmlLine(onlineSale, 'DateDebutVisibilite')}
            ${getXmlLine(onlineSale, 'DateFinVisibilite')}
            ${getXmlBoolean(onlineSale, 'IsAfficheEnLigne')}
            ${getXmlBoolean(onlineSale, 'RedescendreVenteEnLigne')}
        </d4p1:${name}>
    `;
}

export function catalogBenefitsProductSalesToXML(onlineSale: PrestationProduitVenteEnLigneModel): string {
    return `
<d4p1:ProduitVenteEnLigneModel>
    ${getXmlBoolean(onlineSale, 'AutoriserCommandesEnLigne')}
    ${getXmlLine(onlineSale, 'DateDebutVisibilite')}
    ${getXmlLine(onlineSale, 'DateFinVisibilite')}
    ${getXmlLine(onlineSale, 'IdElement', {defaultValue: 0})}
    ${getXmlBoolean(onlineSale, 'IsAfficheEnLigne', {defaultValue: false})}
    ${getXmlBoolean(onlineSale, 'IsDateDebutObligatoire', {defaultValue: false})}
    ${getXmlBoolean(onlineSale, 'IsDateFinObligatoire', {defaultValue: false})}
    ${getXmlBoolean(onlineSale, 'IsDossierSimplifieEnLigne', {defaultValue: false})}
    ${getXmlBoolean(onlineSale, 'IsRefFactureObligatoire', {defaultValue: false})}
    ${getXmlLine(onlineSale, 'LibellePrestaDateDebutActivite', {defaultValue: ''})}
    ${getXmlLine(onlineSale, 'LibellePrestaDateFacture', {defaultValue: ''})}
    ${getXmlLine(onlineSale, 'LibellePrestaDateFinActivite', {defaultValue: ''})}
    ${getXmlLine(onlineSale, 'LibellePrestaMontantPresente', {defaultValue: ''})}
    ${getXmlLine(onlineSale, 'LibellePrestaMontantPrisEnCompte', {defaultValue: ''})}
    ${getXmlLine(onlineSale, 'LibellePrestaReferenceFacture', {defaultValue: ''})}
    ${getXmlBoolean(onlineSale, 'RedescendreVenteEnLigne')}
</d4p1:ProduitVenteEnLigneModel>
    `;
}

export function catalogAccountingToXML(imputation: ActivityCatalogAccounting): string {
    return `
        <d4p1:ImputationComptable
            i:type="d5p1:ImputationComptableEditerImputationFPATousComptes"
            xmlns:d5p1="http://schemas.datacontract.org/2004/07/V2DTO.ImputationComptable"
            xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
            ${getXmlLine(imputation, 'IsRedescente', {namespace: 'd5p1'})}
            <d5p1:ListePlansAnalytiques>
                ${imputation.ListePlansAnalytiques.anyType.map(plan => `
                    <d6p1:anyType i:type="d4p1:PlanWithSectionsAnalytiquesModel">
                        ${getXmlLine(plan, 'IdPlan')}
                        ${getXmlLine(plan, 'IdSectionAnalytique')}
                    </d6p1:anyType>
                `).join('')}
            </d5p1:ListePlansAnalytiques>
            ${getXmlLine(imputation, 'IdCompteCharge', {namespace: 'd5p1'})}
            ${getXmlLine(imputation, 'IdCompteProduit', {namespace: 'd5p1'})}
            <d5p1:IsKdo>false</d5p1:IsKdo>
            <d5p1:IsPac>false</d5p1:IsPac>
            ${getXmlLine(imputation, 'IdCompteValorisation', {namespace: 'd5p1'})}
            ${getXmlLine(imputation, 'IdCompteVariation', {namespace: 'd5p1'})}
        </d4p1:ImputationComptable>
    `;
}

export function catalogBenefitsAccountingToXML(imputation: ImputationComptableEditerImputationFpaCharge): string {
    return `
        <d4p1:ImputationComptable
            i:type="d8p1:ImputationComptableEditerImputationFPACharge"
            xmlns:d8p1="http://schemas.datacontract.org/2004/07/V2DTO.ImputationComptable"
            xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
            ${getXmlLine(imputation, 'IsRedescente', {namespace: 'd8p1'})}
            <d8p1:ListePlansAnalytiques>
                ${imputation.ListePlansAnalytiques.anyType.map(plan => `
                    <d6p1:anyType i:type="d4p1:PlanWithSectionsAnalytiquesModel">
                        ${getXmlLine(plan, 'IdPlan')}
                        ${getXmlLine(plan, 'IdSectionAnalytique')}
                    </d6p1:anyType>
                `).join('')}
            </d8p1:ListePlansAnalytiques>
            ${getXmlLine(imputation, 'IdCompteCharge', {namespace: 'd8p1'})}
        </d4p1:ImputationComptable>
    `;
}

export function catalogLoansAccountingToXML(imputation: PretsEtDonsImputationComptableModel, name: string): string {
    return `
        <d4p1:${name}
            xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
            ${getXmlLine(imputation, 'IdCompteCharges', {namespace: 'd4p1'})}
            ${getXmlLine(imputation, 'IdCompteCollectifPret', {namespace: 'd4p1'})}
            ${getXmlLine(imputation, 'IdCompteFraisDossier', {namespace: 'd4p1'})}
            ${getXmlBoolean(imputation, 'IsApplicationSurEnfants', {namespace: 'd4p1'})}
            ${arrayNotEmpty(imputation?.ListePlanSectionAnalytique?.PlanWithSectionsAnalytiquesModel) ? `
            <d4p1:ListePlanSectionAnalytique>
                ${imputation.ListePlanSectionAnalytique.PlanWithSectionsAnalytiquesModel.map(plan => `
                    <d4p1:PlanWithSectionsAnalytiquesModel>
                        ${getXmlLine(plan, 'IdPlan')}
                        ${getXmlLine(plan, 'IdSectionAnalytique')}
                    </d4p1:PlanWithSectionsAnalytiquesModel>
                `).join('')}
            </d4p1:ListePlanSectionAnalytique>
            ` : ''}
        </d4p1:${name}>
    `;
}

type AccountingTypes = ImputationComptableEditerImputationFpaProduitCharge
    | ImputationComptableEditerImputationFpaProduit
    | ImputationComptableEditerImputationFpaCharge
    | ImputationComptableEditerImputationFpaVariationValorisation
    | ImputationComptableEditerImputationFpaTousComptes;

export function catalogBenefitsProductAccountingToXML(imputation: AccountingTypes, settings: ParametragePrestationModel): string {
    const {IsRemboursement, IsCadeau, IsPartACharge} = settings;

    const type = IsRemboursement
        ? 'ImputationComptableEditerImputationFPACharge'
        : 'ImputationComptableEditerImputationFPAProduitCharge';

    return `
        <d4p1:ImputationComptable
            i:type="d7p1:${type}"
            xmlns:d7p1="http://schemas.datacontract.org/2004/07/V2DTO.ImputationComptable">
            ${getXmlLine(imputation, 'IdElement', {namespace: 'd7p1', defaultValue: 0})}
            ${getXmlBoolean(imputation, 'IsRedescente', {namespace: 'd7p1', defaultValue: false})}
            <d7p1:ListePlansAnalytiques>
                ${imputation.ListePlansAnalytiques.anyType.map(plan => `
                    <d6p1:anyType i:type="d4p1:PlanWithSectionsAnalytiquesModel">
                        ${getXmlLine(plan, 'IdPlan')}
                        ${getXmlLine(plan, 'IdSectionAnalytique')}
                    </d6p1:anyType>
                `).join('')}
            </d7p1:ListePlansAnalytiques>
            ${getXmlLine(imputation, 'IdCompteCharge', {namespace: 'd7p1'})}
            ${!IsRemboursement ? `
            ${getXmlLine(imputation, 'IdCompteProduit', {namespace: 'd7p1'})}
            <d7p1:IsKdo>${imputation.IsRedescente ? IsCadeau : false}</d7p1:IsKdo>
            <d7p1:IsPac>${imputation.IsRedescente ? IsPartACharge : false}</d7p1:IsPac>
            ` : ''}
        </d4p1:ImputationComptable>
    `;
}

export function catalogPointCounterToXML(pointsCounters: ListeCompteursPointsFpa): string {
    return `
        <d4p1:CompteursDePoints>
            <d4p1:IsRedescente>${pointsCounters?.IsRedescente || false}</d4p1:IsRedescente>
            ${arrayNotEmpty(pointsCounters?.ListeCompteursPoints?.anyType) ? `
            <d4p1:ListeCompteursPoints xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
                ${pointsCounters.ListeCompteursPoints.anyType.map(counter => `
                    <d6p1:anyType i:type="d4p1:CompteurPointAFPAModel">
                        ${getXmlLine(counter, 'IdAFPA')}
                        ${getXmlLine(counter, 'IdCompteur')}
                        ${getXmlLine(counter, 'IsDeleted')}
                        ${getXmlLine(counter, 'IsFromFirstEuro')}
                        ${getXmlLine(counter, 'MontantSub')}
                        ${getXmlLine(counter, 'Valeur')}
                    </d6p1:anyType>
            `).join('')}
            </d4p1:ListeCompteursPoints>
            ` : ''}
        </d4p1:CompteursDePoints>
    `;
}

export function catalogCustomFieldsToXML(customFields: ChampEditerChampPersoFpa[]): string {
    return arrayNotEmpty(customFields) ? `
        <d4p1:ListeChampsPersonnalises
            xmlns:d5p1="http://schemas.datacontract.org/2004/07/V2DTO.Champ"
            xmlns:d7p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
            xmlns:d8p2="http://schemas.datacontract.org/2004/07/V2DTO.ChampListeValeur">
            ${customFields.map(field => `
                <d5p1:ChampEditerChampPersoFPA>
                    ${getXmlLine(field, 'CodeChamp', {namespace: 'd5p1'})}
                    ${getXmlLine(field, 'CodeTypeChamp', {namespace: 'd5p1'})}
                    ${getXmlLine(field, 'CodeValeur', {namespace: 'd5p1'})}
                    ${getXmlLine(field, 'IdChamp', {namespace: 'd5p1', defaultValue: 0})}
                    ${getXmlLine(field, 'IdArticle', {namespace: 'd5p1'})}
                    ${getXmlLine(field, 'IdChpValMbr', {namespace: 'd5p1', defaultValue: 0})}
                    ${getXmlLine(field, 'IdFamille', {namespace: 'd5p1'})}
                    ${getXmlLine(field, 'IdProduit', {namespace: 'd5p1'})}
                    ${getXmlLine(field, 'IdValeur', {namespace: 'd5p1'})}
                    ${getXmlBoolean(field, 'IsAppliqueActivite', {namespace: 'd5p1', defaultValue: false})}
                    ${getXmlBoolean(field, 'IsAppliqueArticle', {namespace: 'd5p1', defaultValue: false})}
                    ${getXmlBoolean(field, 'IsAppliqueFamille', {namespace: 'd5p1', defaultValue: false})}
                    ${getXmlBoolean(field, 'IsAppliqueProduit', {namespace: 'd5p1', defaultValue: false})}
                    ${getXmlBoolean(field, 'IsDeleted', {namespace: 'd5p1', defaultValue: false})}
                    ${getXmlLine(field, 'LibelleChamp', {namespace: 'd5p1'})}
                    <d5p1:ListeValeursPossible>
                        ${(field.ListeValeursPossible?.anyType || []).map(value => `
                            <d7p1:anyType i:type="d8p2:ChampListeValeurChampListeValeurModel">
                                ${getXmlLine(value, 'CodeChampValeur', {namespace: 'd8p2'})}
                                ${getXmlLine(value, 'Id', {namespace: 'd8p2', defaultValue: 0})}
                                ${getXmlLine(value, 'IdChamp', {namespace: 'd8p2', defaultValue: 0})}
                                ${getXmlLine(value, 'IsCloture', {namespace: 'd8p2'})}
                                ${getXmlLine(value, 'Valeur', {namespace: 'd8p2'})}
                            </d7p1:anyType>
                        `).join('')}
                    </d5p1:ListeValeursPossible>
                    ${getXmlLine(field, 'Valeur', {namespace: 'd5p1'})}
                </d5p1:ChampEditerChampPersoFPA>
            `).join('')}
        </d4p1:ListeChampsPersonnalises>
    ` : '';
}

export function catalogStockMangagementToXML(stockManagement: ParametrageStockFpaModel): string {
    return `
        <d4p1:GestionStock>
            ${getXmlLine(stockManagement, 'DateReappro')}
            ${getXmlLine(stockManagement, 'IdTypeReappro')}
            ${getXmlBoolean(stockManagement, 'IsGestionEnStock')}
            ${getXmlBoolean(stockManagement, 'IsSurStockDisponible')}
            ${getXmlBoolean(stockManagement, 'IsSurStockDisponibleAttente')}
            ${getXmlBoolean(stockManagement, 'IsSurStockReel')}
            ${getXmlLine(stockManagement, 'TypeFonctionnement')}
        </d4p1:GestionStock>
    `;
}

export function catalogArticlePriceToXML(prices: PrixArticleModel): string {
    return `
    <d4p1:PrixArticle
        xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
        xmlns:d7p2="http://schemas.datacontract.org/2004/07/V2DTO.AFPA.Articles">
        ${getXmlLine(prices, 'IdFournisseurFavoris')}
        ${getXmlLine(prices, 'IsPrixPublicDisplayed', {defaultValue: false})}
        ${arrayNotEmpty(prices.ListePrixAchat?.anyType) ? `
            <d4p1:ListePrixAchat>
            ${prices.ListePrixAchat.anyType.map(price => `
            <d6p1:anyType i:type="d7p2:ArticlesHistoriquePrixAchatArticle">
              ${getXmlLine(price, 'CommentairePrix', {defaultValue: '', namespace: 'd7p2'})}
              ${getXmlLine(price, 'DateDebutPrix', {namespace: 'd7p2'})}
              ${getXmlLine(price, 'DateFinPrix', {namespace: 'd7p2'})}
              ${getXmlLine(price, 'IdArticleFournisseur', {namespace: 'd7p2'})}
              ${getXmlLine(price, 'IdFournisseur', {namespace: 'd7p2'})}
              ${getXmlLine(price, 'IsDeleted', {namespace: 'd7p2'})}
              ${getXmlLine(price, 'IsRemiseCumulee', {namespace: 'd7p2'})}
              ${getXmlLine(price, 'Prix', {namespace: 'd7p2'})}
              ${getXmlLine(price, 'PrixPublic', {namespace: 'd7p2'})}
              ${getXmlLine(price, 'ReferencePrix', {namespace: 'd7p2'})}
              ${getXmlLine(price, 'RemiseArticle', {namespace: 'd7p2'})}
            </d6p1:anyType>
        `).join('')}
            </d4p1:ListePrixAchat>
        ` : ''}
        ${arrayNotEmpty(prices.ListePrixVente?.anyType) ? `
         <d4p1:ListePrixVente>
            ${prices.ListePrixVente.anyType.map(price => `
                <d6p1:anyType i:type="d7p2:ArticlesHistoriquePrixVenteArticle">
                    ${getXmlLine(price, 'DateDebutPrix', {namespace: 'd7p2'})}
                    ${getXmlLine(price, 'DateFinPrix', {namespace: 'd7p2'})}
                    ${getXmlLine(price, 'IdArticle', {namespace: 'd7p2'})}
                    ${getXmlLine(price, 'IdArticlePrixVente', {namespace: 'd7p2'})}
                    ${getXmlLine(price, 'IsDeleted', {namespace: 'd7p2'})}
                    ${getXmlLine(price, 'LibelleArticle', {namespace: 'd7p2'})}
                    ${getXmlLine(price, 'Prix', {namespace: 'd7p2'})}
                </d6p1:anyType>
            `).join('')}
         </d4p1:ListePrixVente>
         ` : ''}
         ${getXmlLine(prices, 'PrixPublic')}
    </d4p1:PrixArticle>
    `;
}

export function catalogArticleANCVCouponsToXML(chequebook: EditChequierAncv, {isChequierDynamique}: {
    isChequierDynamique: boolean
}): string {
    return `
        <d4p1:ChequierANCV>
        ${isChequierDynamique ? `
        ${arrayNotEmpty(chequebook?.CompositionChequierDynamique?.anyType) ? `
            <d4p1:CompositionChequierDynamique xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
                ${chequebook.CompositionChequierDynamique.anyType.map(composition => `
                    <d6p1:anyType i:type="d4p1:ArticleChequierBorneModel">
                        ${arrayNotEmpty(composition.CompositionChequier?.anyType) ? `
                            <d4p1:CompositionChequier>
                            ${composition.CompositionChequier.anyType.map(cheque => `
                                <d6p1:anyType i:type="d4p1:CompositionChequeModel">
                                    ${getXmlLine(cheque, 'IdArticleCheque')}
                                    ${getXmlLine(cheque, 'IdCheque', {defaultValue: ''})}
                                    ${getXmlLine(cheque, 'NombreCheques', {defaultValue: 0})}
                                </d6p1:anyType>
                            `).join('')}
                            </d4p1:CompositionChequier>
                        ` : ''}
                        ${getXmlLine(composition, 'IdBorne')}
                        ${getXmlLine(composition, 'IsDefaultComposition')}
                        ${getXmlLine(composition, 'IsDeleted')}
                        ${!composition.IsDefaultComposition ? `
                            ${getXmlLine(composition, 'MontantMax')}
                            ${getXmlLine(composition, 'MontantMin')}
                        ` : ''}
                    </d6p1:anyType>
                `).join('')}
            </d4p1:CompositionChequierDynamique>
        ` : ''}
        ` : `
            ${arrayNotEmpty(chequebook?.CompositionChequierGenerique?.anyType) ? `
                <d4p1:CompositionChequierGenerique
                xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
                ${chequebook.CompositionChequierGenerique.anyType.map(composition => `
                    <d6p1:anyType i:type="d4p1:ArticleChequierModel">
                        ${getXmlLine(composition, 'IdArticleCheque')}
                        ${getXmlLine(composition, 'IdCheque')}
                        ${getXmlLine(composition, 'NombreCheques')}
                    </d6p1:anyType>
                `).join('')}
                </d4p1:CompositionChequierGenerique>
            ` : ''}
        `}
            ${getXmlLine(chequebook, 'IdModeEnvoiANCV')}
        </d4p1:ChequierANCV>
    `;
}

export function catalogRulesToXML(rules: ListesReglesAfpaModel, activityType?: TypeActivite): string {
    const rulesTriageToXML = (source: RegleAfpaModel[] = [], ruleToXMLCallback: (rule: RegleAfpaModel, type?: TypeActivite) => string): string => {
        return source.map(rule => {
            if (rule.IsDeleted) {
                return catalogDeletedRule(rule);
            }

            if (rule.IsRegleHeritage) {
                return rule.IsUsedRegleHeritee ? catalogInheritedRuleToXML(rule) : '';
            }

            if (rule.IsRegleTransverse) {
                return rule.IsRegleAttribution ? catalogAttributionRuleToXML(rule) : catalogTransversalRuleToXML(rule);
            }

            if (rule.IsRegleExpert) {
                if (rule.IsRegleComplementaire) {
                    return getComplementaryRule(rule);
                }

                return catalogAdvancedRuleToXML(rule);
            }

            return !!rule.ModeleRegle ? ruleToXMLCallback(rule, activityType) : '';
        }).join('');
    };

    return `
        <d4p1:Regles>
            ${arrayNotEmpty(rules?.ListeReglesAccessibilite?.RegleAFPAModel) ? `
                <d4p1:ListeReglesAccessibilite>
                    ${rulesTriageToXML(rules.ListeReglesAccessibilite.RegleAFPAModel, catalogAccessibilityRuleToXML)}
                </d4p1:ListeReglesAccessibilite>
            ` : ''}
            ${arrayNotEmpty(rules?.ListeReglesEnveloppe?.RegleAFPAModel) ? `
                <d4p1:ListeReglesEnveloppe>
                    ${rulesTriageToXML(rules.ListeReglesEnveloppe.RegleAFPAModel, catalogEnvelopeRuleToXML)}
                </d4p1:ListeReglesEnveloppe>
            ` : ''}
            ${arrayNotEmpty(rules?.ListeReglesQuota?.RegleAFPAModel) ? `
                <d4p1:ListeReglesQuota>
                    ${rulesTriageToXML(rules.ListeReglesQuota.RegleAFPAModel, catalogQuotaRuleToXML)}
                </d4p1:ListeReglesQuota>
            ` : ''}
            ${arrayNotEmpty(rules?.ListeReglesSubvention?.RegleAFPAModel) ? `
                <d4p1:ListeReglesSubvention>
                    ${rulesTriageToXML(rules.ListeReglesSubvention.RegleAFPAModel, catalogSubventionRuleToXML)}
                </d4p1:ListeReglesSubvention>
            ` : ''}
        </d4p1:Regles>
    `;
}

function catalogAdvancedRuleToXML(rule: RegleAfpaModel): string {
    return `
        <d4p1:RegleAFPAModel>
            ${getXmlLine(rule, 'IdRegle')}
            ${getXmlBoolean(rule, 'IsRegleTransverse')}
            ${!!rule?.ModeleRegleExpert ? `
                <d4p1:ModeleRegleExpert xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/">
                    ${getXmlLine(rule.ModeleRegleExpert, 'Id')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsCloture')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsComplementaire')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsForcageAutorise')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsModifiableRegle')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsRegleAfaireHerite')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsRegleAvancee')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsRegleNiveauUn')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsRegleUse')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsRglBudget')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsSansSubventionAudelaLimite')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsSubChoisie')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsTransverse')}
                    ${getXmlLine(rule.ModeleRegleExpert, 'LibelleRegle')}
                    <d4p1:ListeIdRglUseAct i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRglUseAct>
                    <d4p1:ListeIdRglUseArt i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRglUseArt>
                    <d4p1:ListeIdRglUseFam i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRglUseFam>
                    <d4p1:ListeIdRglUsePrd i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRglUsePrd>
                    <d4p1:ListeIdRgleHerAct i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRgleHerAct>
                    <d4p1:ListeIdRgleHerFam i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRgleHerFam>
                    <d4p1:ListeIdRgleHerPrd i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRgleHerPrd>
                    ${advancedRuleFPAToXML(rule.ModeleRegleExpert?.RegleAvancee)}
                    ${getXmlLine(rule.ModeleRegleExpert, 'TypeRegle')}
                    ${getXmlLine(rule.ModeleRegleExpert, 'TypeValeur')}
                    ${getXmlLine(rule.ModeleRegleExpert, 'TypeValeurLimite')}
                </d4p1:ModeleRegleExpert>
            ` : ''}
    </d4p1:RegleAFPAModel>
    `;
}

function getComplementaryRule(rule: RegleAfpaModel): string {
    return `
        <d4p1:RegleAFPAModel>
            ${getXmlLine(rule, 'Status')}
            ${getXmlLine(rule, 'IdModeleRegle', {defaultValue: 0})}
            ${getXmlLine(rule, 'IdRegle', {defaultValue: 0})}
            ${getXmlBoolean(rule, 'IsDeleted', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleTransverse', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleComplementaire', {defaultValue: true})}
            ${getXmlBoolean(rule, 'IsRegleExpert', {defaultValue: true})}
            ${getXmlLine(rule.ModeleRegleExpert, 'LibelleRegle')}
            ${!!rule?.ModeleRegleExpert ? `
                <d4p1:ModeleRegleExpertSubventionComplementaire xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/">
                    ${getXmlLine(rule.ModeleRegleExpert, 'Status')}
                    ${getXmlLine(rule.ModeleRegleExpert, 'Id', {defaultValue: 0})}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IdEnveloppe')}
                    ${getXmlBoolean(rule.ModeleRegleExpert, 'IsHeritee')}
                    ${getXmlLine(rule.ModeleRegleExpert, 'Libelle', {defaultValue: rule.ModeleRegleExpert.LibelleRegle})}
                    ${getXmlLine(rule, 'Ordre')}
                    ${advancedRuleFPAToXML(rule.ModeleRegleExpert?.RegleAvancee)}
                </d4p1:ModeleRegleExpertSubventionComplementaire>
            ` : ''}
            ${getXmlLine(rule, 'Ordre')}
    </d4p1:RegleAFPAModel>
    `;
}

export function catalogRulesModelToXml(rules: ModeleSaveReglesAfpadto): string {
    return `
<d4p1:ModeleSaveReglesAFPA>
    <d4p1:Status>INSERTED</d4p1:Status>
    ${getXmlLine(rules, 'IdElement')}
    ${getXmlLine(rules, 'IdParent')}
    <d4p1:ListeRegles xmlns:arrays="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
    ${
        arrayNotEmpty(rules?.ListeRegles?.anyType) ? `
        ${rules.ListeRegles.anyType.map(rule => {
            const status = (!rule.IdRegle || !rule.Status) ? StatusDtoEnum.Inserted : rule.Status;
            return `<arrays:anyType i:type="d4p1:RegleExpertModel">
            <Status xmlns="http://schemas.datacontract.org/2004/07/V2DTO">${status}</Status>
            ${getXmlLine(rule, 'IdRegle', {defaultValue: 0})}
            ${getXmlBoolean(rule, 'IsAccessibilite')}
            ${getXmlBoolean(rule, 'IsEnveloppe')}
            ${getXmlBoolean(rule, 'IsHerite')}
            ${getXmlBoolean(rule, 'IsModeExpert')}
            ${getXmlBoolean(rule, 'IsQuota')}
            ${getXmlBoolean(rule, 'IsRegleHeritage')}
            ${getXmlBoolean(rule, 'IsRestantACharge')}
            ${getXmlBoolean(rule, 'IsSubvention')}
            ${getXmlBoolean(rule, 'IsSubventionComplementaire')}
            ${getXmlLine(rule, 'Libelle')}
            ${getXmlBoolean(rule, 'NeedsToBeDeleted')}
        </arrays:anyType>
        `;
        }).join('')}
        ` : ''
    }
    </d4p1:ListeRegles>
    <d4p1:ModeleDeploiementRegles i:type="d4p1:ModeleDeploiementReglesBase">
        ${getXmlBoolean(rules?.ModeleDeploiementRegles, 'RedescenteRegleAccessibilite')}
        ${getXmlBoolean(rules?.ModeleDeploiementRegles, 'RedescenteRegleQuota')}
    </d4p1:ModeleDeploiementRegles>
    <d4p1:ModeleRegleAccChplistval xmlns:arrays="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
        ${(rules?.ModeleRegleAccChplistval?.anyType || []).map(criteria => `
                <arrays:anyType i:type="d4p1:ModeleRegleAccChpListValModeGuide">
                    ${getXmlLine(criteria, 'IdChpListVal')}
                    ${getXmlLine(criteria, 'IsCheckedValeur', {defaultValue: false})}
                    ${getXmlLine(criteria, 'Libelle')}
                    ${getXmlLine(criteria, 'ValeurAncienneteMax')}
                    ${getXmlLine(criteria, 'ValeurAncienneteMin')}
                </arrays:anyType>
            `).join('')}
    </d4p1:ModeleRegleAccChplistval>
    ${catalogLoansAccessibilityRuleXml(rules?.ModeleRegleAccessibilite)}
    ${getQuotaLoansRuleXml(rules?.ModeleRegleSubQuota)}
    ${getXmlLine(rules, 'TypeElement')}
</d4p1:ModeleSaveReglesAFPA>
    `;
}

export function catalogDeletedRule(rule: RegleAfpaModel): string {
    return `
        <d4p1:RegleAFPAModel>
            ${getXmlLine(rule, 'IdRegle')}
            <d4p1:IsDeleted>true</d4p1:IsDeleted>
        </d4p1:RegleAFPAModel>
    `;
}

export function catalogInheritedRuleToXML(rule: RegleAfpaModel): string {
    return `
        <d4p1:RegleAFPAModel>
            ${getXmlLine(rule, 'IdRegle')}
            <d4p1:IsRegleHeritage>true</d4p1:IsRegleHeritage>
            <d4p1:IsUsedRegleHeritee>true</d4p1:IsUsedRegleHeritee>
        </d4p1:RegleAFPAModel>
    `;
}

export function catalogTransversalRuleToXML(rule: RegleAfpaModel): string {
    return `
        <d4p1:RegleAFPAModel>
            ${getXmlLine(rule, 'IdRegle')}
            <d4p1:IsRegleTransverse>true</d4p1:IsRegleTransverse>
        </d4p1:RegleAFPAModel>
    `;
}

export function catalogAttributionRuleToXML(rule: RegleAfpaModel): string {
    return `
        <d4p1:RegleAFPAModel>
            ${getXmlLine(rule, 'IdRegle')}
            <d4p1:IsRegleAttribution>true</d4p1:IsRegleAttribution>
        </d4p1:RegleAFPAModel>
    `;
}

export function catalogAccessibilityRuleToXML(rule: RegleAfpaModel, activityType?: TypeActivite): string {
    return `
    <d4p1:RegleAFPAModel>
        ${getXmlLine(rule, 'IdRegle', {defaultValue: 0})}
        ${getXmlLine(rule, 'IsDeleted', {defaultValue: false})}
        ${getXmlLine(rule, 'IsRegleHeritage', {defaultValue: false})}
        ${getXmlLine(rule, 'IsRegleTransverse', {defaultValue: false})}
        ${getXmlLine(rule, 'IsUsedRegleHeritee', {defaultValue: false})}
        ${catalogAccessibilityRuleModelToXML(rule.ModeleRegle, activityType)}
        ${getXmlLine(rule, 'Ordre')}
        <d4p1:TypeRegleBase>ACC</d4p1:TypeRegleBase>
    </d4p1:RegleAFPAModel>
    `;
}

function catalogLoansAccessibilityRuleXml(rule: ModeleRegleAccessibilitePretsEtDonsInput): string {
    return !!rule ? `
<d4p1:ModeleRegleAccessibilite i:type="d4p1:ModeleRegleAccessibilitePretsEtDons">
    ${getXmlLine(rule, 'Status')}
    ${getXmlLine(rule, 'IdChampOuvrantDroit')}
    ${getXmlLine(rule, 'IdModeleRegle', {defaultValue: 0})}
    ${getXmlLine(rule, 'IdTypeDateCalculAnciennete')}
    ${getXmlBoolean(rule, 'IsAccessibleSelonCritere')}
    ${getXmlBoolean(rule, 'IsAccessibleTousOuvrantsDroit')}
    ${getXmlLine(rule, 'JourDateFixe')}
    ${getXmlLine(rule, 'ModeCalculAccessibilite')}
    ${getXmlLine(rule, 'MoisDateFixe')}
    ${getXmlLine(rule, 'NbMoisAncienneteMax')}
    ${getXmlLine(rule, 'NbMoisAncienneteMin')}
    ${getXmlLine(rule, 'NombreMoisAvantFinContrat')}
</d4p1:ModeleRegleAccessibilite>
    ` : '';
}

function getQuotaLoansRuleXml(rule: ModeleRegleQuotaPretsEtDonsInput): string {
    if (!rule?.IdModeleRegle) {
        if (!rule) {
            rule = {};
        }
        rule.Status = StatusDtoEnum.Inserted;
    }
    return `
<d4p1:ModeleRegleSubQuota i:type="d4p1:ModeleRegleQuotaPretsEtDons">
    ${getXmlLine(rule, 'Status')}
    ${getXmlLine(rule, 'IdModeleRegle', {defaultValue: 0})}
    ${getXmlBoolean(rule, 'IsForcageAutorise')}
    ${getXmlBoolean(rule, 'IsVenteSansSubvention')}
    ${getXmlLine(rule, 'OrdreModeleRegle', {defaultValue: 0})}
    ${getXmlLine(rule, 'IdChpListValMontantPeriodeMaximunPretsOuDonsAccodes')}
    ${getXmlLine(rule, 'IdChpListValNombrePeriodeMaximunPretsOuDonsAccodes')}
    ${getXmlLine(rule, 'MontantMaximunPretsOuDonsAccodes')}
    ${getXmlLine(rule, 'NombreMaximunDemandesAttente')}
    ${getXmlLine(rule, 'NombreMaximunPretsOuDonsAccodes')}
    ${getXmlLine(rule, 'NombreMaximunPretsOuDonsAccodes')}
    ${getXmlLine(rule, 'NombreMaximunPretsSimultanes')}
</d4p1:ModeleRegleSubQuota>
    `;
}

export function catalogAccessibilityRuleModelToXML(model: any, activityType?: TypeActivite): string {
    return `
        <d4p1:ModeleRegle i:type="d4p1:${model.__typename || 'ModeleRegleAFPAAccessibiliteOuvrantDroit'}">
            ${getXmlLine(model, 'IdModeleRegle')}
            ${getXmlLine(model, 'IdRegle')}
            ${getXmlBoolean(model, 'IsRegleTransverse', {defaultValue: false})}
            ${getXmlLine(model, 'LibelleRegle', {defaultValue: ''})}
            ${getXmlBoolean(model, 'AllowForcage', {defaultValue: false})}
            ${getXmlLine(model, 'IdChampOD')}
            ${getXmlLine(model, 'AncienneteMaximumOD')}
            ${getXmlLine(model, 'AncienneteMinimumOD')}
            ${getXmlLine(model, 'IdTypeDateCalculAnciennete')}
            ${getXmlLine(model, 'JourDateReference')}
            ${arrayNotEmpty(model.ListeCriteresOD.anyType) ? `
                <d4p1:ListeCriteresOD xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
                    ${model.ListeCriteresOD.anyType.map(criterion => `
                      <d9p1:anyType i:type="d4p1:ModeleRegleAccChpListValModeGuide">
                        ${getXmlBoolean(criterion, 'MustValidate', {defaultValue: false})}
                        ${getXmlLine(criterion, 'MyGuid')}
                        ${getXmlLine(criterion, 'Status')}
                        ${getXmlLine(criterion, 'IdChpListVal')}
                        ${getXmlLine(criterion, 'IdRegleAccessibilite')}
                        ${getXmlLine(criterion, 'IsCheckedValeur')}
                        ${getXmlLine(criterion, 'Libelle')}
                        ${getXmlLine(criterion, 'ValeurAncienneteMax')}
                        ${getXmlLine(criterion, 'ValeurAncienneteMin')}
                      </d9p1:anyType>
                    `).join('')}
                </d4p1:ListeCriteresOD>
            ` : ''}
            ${getXmlLine(model, 'MoisDateReference')}
            ${getXmlLine(model, 'TypeAccessibiliteOD')}
            ${getXmlBoolean(model, 'IsAccessibiliteConjoint', {defaultValue: false})}
            ${getXmlBoolean(model, 'IsAccessibiliteEnfant', {defaultValue: false})}
            ${getXmlBoolean(model, 'IsAccessibiliteExterne', {defaultValue: false})}
            ${getXmlBoolean(model, 'IsAccessibiliteOuvrantDroit', {defaultValue: false})}
            ${getXmlLine(model, 'AgeEnfantMaximum', {defaultValue: null})}
            ${getXmlLine(model, 'AgeEnfantMinimum', {defaultValue: null})}
            ${getXmlLine(model, 'IdTypeDateCalculAgeEnfant', {defaultValue: null})}
            ${getXmlBoolean(model, 'IsConjointHandicape', {defaultValue: false})}
            ${getXmlBoolean(model, 'IsEnfantACharge', {defaultValue: false})}
            ${getXmlBoolean(model, 'IsEnfantDirect', {defaultValue: false})}
            ${getXmlBoolean(model, 'IsEnfantHandicape', {defaultValue: false})}
            ${getXmlLine(model, 'JourDateReferenceEnfant')}
            ${arrayNotEmpty(model.ListeIdChampAD?.decimal) ? `
                <d4p1:ListeCriteresAD xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
                    ${model.ListeIdChampAD.decimal.map(idChampAD => `
                        <d9p1:anyType i:type="d4p1:ModeleRegleAccChpListValModeGuide">
                            <d4p1:Status>${StatusDtoEnum.Inserted}</d4p1:Status>
                            <d4p1:IdChpListVal>${idChampAD}</d4p1:IdChpListVal>
                            <d4p1:IsCheckedValeur>true</d4p1:IsCheckedValeur>
                        </d9p1:anyType>
                    `).join('')}
                </d4p1:ListeCriteresAD>
            ` : ''}
            ${getXmlLine(model, 'MoisDateReferenceEnfant')}
        </d4p1:ModeleRegle>
    `;
}

function getSubventionType(rule: ActivityRulesEditSubvention, type = 'ModeleRegleAFPASubvention'): string {
    return `
        <d4p1:ModeleRegle i:type="d4p1:${type}">
            ${getXmlLine(rule, 'IdModeleRegle')}
            ${getXmlLine(rule, 'IdRegle')}
            ${getXmlLine(rule, 'IsRegleTransverse')}
            ${getXmlLine(rule, 'LibelleRegle')}
            ${getXmlLine(rule, 'Subvention')}
            ${getXmlLine(rule, 'TypeValeur')}
            ${getXmlLine(rule, 'IdChamp')}
            ${arrayNotEmpty(rule.ListeValeurs?.anyType) ? `
                <d4p1:ListeValeurs xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
                xmlns:d10p2="http://schemas.datacontract.org/2004/07/V2DTO.Regle.Subvention">
                    ${rule.ListeValeurs.anyType.filter((e) => e.Montant > 0 || e.BorneMaximum > 0 || e.BorneMinimum > 0).map(criterion => `
                        <d9p1:anyType i:type="d10p2:SubventionValeurCritereModele">
                            ${getXmlLine(criterion, 'BorneMaximum', {namespace: 'd10p2'})}
                            ${getXmlLine(criterion, 'BorneMinimum', {namespace: 'd10p2'})}
                            ${getXmlLine(criterion, 'IdBorne', {namespace: 'd10p2'})}
                            ${getXmlLine(criterion, 'IdChampValeur', {namespace: 'd10p2'})}
                            ${getXmlLine(criterion, 'IdModeleRegle', {defaultValue: '0', namespace: 'd10p2'})}
                            ${getXmlLine(criterion, 'IdValeur', {namespace: 'd10p2'})}
                            ${getXmlLine(criterion, 'Montant', {namespace: 'd10p2'})}
                        </d9p1:anyType>
                    `).join('')}
                </d4p1:ListeValeurs>
            ` : ''}
            ${getXmlLine(rule, 'SubventionDefault')}
        </d4p1:ModeleRegle>
    `;
}

function getComplementarySubvention(rule: ActivityRulesEditSubvention): string {
    return `
        <d4p1:ModeleRegle i:type="d4p1:ModeleRegleAFPASubventionComplementaire">
            ${getXmlLine(rule, 'IdModeleRegle')}
            ${getXmlLine(rule, 'IdRegle')}
            ${getXmlBoolean(rule, 'IsRegleTransverse', {defaultValue: false})}
            ${getXmlLine(rule, 'LibelleRegle', {defaultValue: ''})}
            ${getXmlLine(rule, 'Subvention')}
            ${getXmlLine(rule, 'TypeValeur')}
            ${getXmlLine(rule, 'IdEnveloppeComplementaire')}
            ${getXmlLine(rule, 'Ordre')}

        </d4p1:ModeleRegle>
    `;
}

export function catalogSubventionRuleToXML(rule: RegleAfpaModel): string {
    const model = rule.ModeleRegle as ActivityRulesEditSubvention;

    const getType = (): string => {
        if (rule.TypeRegleBase === constants.rulesType.subv) {
            if (rule.IsRegleComplementaire) {
                return getComplementarySubvention(model);
            }

            return getSubventionType(model);
        } else if (rule.TypeRegleBase === constants.rulesType.rac) {
            return getSubventionType(model, 'ModeleRegleAFPASubventionRestantACharge');
        }
    };

    return `
        <d4p1:RegleAFPAModel>
            ${getXmlLine(rule, 'IdRegle')}
            ${getXmlBoolean(rule, 'IsDeleted', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleAttribution', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleHeritage', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleTransverse', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsUsedRegleHeritee', {defaultValue: false})}
            ${getType()}
        </d4p1:RegleAFPAModel>
    `;
}

export function catalogEnvelopeRuleToXML(rule: RegleAfpaModel): string {
    return `
        <d4p1:RegleAFPAModel>
            ${getXmlLine(rule, 'IdRegle')}
            ${getXmlBoolean(rule, 'IsDeleted', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleAttribution', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleHeritage', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleTransverse', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsUsedRegleHeritee', {defaultValue: false})}
            ${catalogEnvelopeRuleModelToXML(rule.ModeleRegle as ModeleRegleAfpaEnveloppe)}
        </d4p1:RegleAFPAModel>
    `;
}

export function catalogEnvelopeRuleModelToXML(model: ModeleRegleAfpaEnveloppe): string {
    return `
        <d4p1:ModeleRegle i:type="d4p1:ModeleRegleAFPAEnveloppe">
            ${getXmlLine(model, 'IdModeleRegle')}
            ${getXmlLine(model, 'IdRegle')}
            ${getXmlBoolean(model, 'IsRegleTransverse', {defaultValue: false})}
            ${getXmlLine(model, 'LibelleRegle', {defaultValue: ''})}
            ${getXmlLine(model, 'AgeEnfantMaximum')}
            ${getXmlLine(model, 'AgeEnfantMinimum')}
            ${getXmlBoolean(model, 'AllowForcage', {defaultValue: false})}
            ${getXmlLine(model, 'IdCritereChamp')}
            ${getXmlLine(model, 'IdPeriode')}
            ${getXmlLine(model, 'IdTypeDateReference')}
            ${getXmlBoolean(model, 'IsEachOuvrantDroit', {defaultValue: false})}
            ${getXmlBoolean(model, 'IsEnfantACharge')}
            ${getXmlBoolean(model, 'IsEnfantDirect')}
            ${getXmlBoolean(model, 'IsEnfantHandicape')}
            ${getXmlBoolean(model, 'IsMoisEntierUniquement')}
            ${getXmlBoolean(model, 'IsNominatif')}
            ${getXmlBoolean(model, 'IsPondereMoisPresence')}
            ${getXmlBoolean(model, 'IsPondereTempsTravail')}
            ${getXmlLine(model, 'JourDateReference')}
            ${model.IsEachOuvrantDroit && arrayNotEmpty(model.ListeValeurs?.anyType)
        ? `
                <d4p1:ListeValeurs
                    xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
                    xmlns:d10p2="http://schemas.datacontract.org/2004/07/V2DTO.Regle.Subvention">
                    ${beneficiariesCriteriasModelToXML(model.ListeValeurs.anyType)}
                </d4p1:ListeValeurs>`
        : ''}
            <d4p1:ListeValeursDefault
                xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
                xmlns:d10p2="http://schemas.datacontract.org/2004/07/V2DTO.Regle.Subvention">
                ${beneficiariesCriteriasModelToXML(model.ListeValeursDefault?.anyType || [])}
            </d4p1:ListeValeursDefault>
            ${getXmlLine(model, 'MoisDateReference')}
            ${!model.IsEachOuvrantDroit ? getXmlLine(model, 'QuantiteAllOuvrantDroit') : ''}
            <d4p1:AllowSansSubvention>${model.AllowSansSubvention}</d4p1:AllowSansSubvention>
        </d4p1:ModeleRegle>
    `;
}

export function beneficiariesCriteriasModelToXML(values: ValeurCriteresAyantsDroitModelInput[]): string {
    return `
        ${values.map(value => `
            <d9p1:anyType i:type="d10p2:ValeurCriteresAyantsDroitModel">
                ${getXmlLine(value, 'BorneMaximum', {namespace: 'd10p2'})}
                ${getXmlLine(value, 'BorneMinimum', {namespace: 'd10p2'})}
                ${getXmlLine(value, 'IdBorne', {namespace: 'd10p2'})}
                ${getXmlLine(value, 'IdChampValeur', {namespace: 'd10p2'})}
                ${getXmlLine(value, 'IdModeleRegle', {namespace: 'd10p2'})}
                ${getXmlLine(value, 'IdValeur', {namespace: 'd10p2'})}
                <d10p2:ListeValeursBeneficiaires>
                    ${['OD', 'CON', 'ENF', 'EXT'].map(beneficiaryType =>
        beneficiaryTypeValueToXML(value.ListeValeursBeneficiaires?.anyType?.find(v => v.TypeBeneficiaire === beneficiaryType), beneficiaryType)
    ).join('')}
                </d10p2:ListeValeursBeneficiaires>
            </d9p1:anyType>
        `).join('')}
    `;
}

export function catalogQuotaRuleToXML(rule: RegleAfpaModel, activityType: TypeActivite): string {
    const isBenefit = activityType === TypeActivite.Prestation;
    return `
        <d4p1:RegleAFPAModel>
            ${getXmlLine(rule, 'IdRegle')}
            ${getXmlBoolean(rule, 'IsDeleted', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleAttribution', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleHeritage', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsRegleTransverse', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsUsedRegleHeritee', {defaultValue: false})}
            ${catalogQuotaRuleModelToXML(rule.ModeleRegle as ModeleRegleAfpaQuota, isBenefit)}
        </d4p1:RegleAFPAModel>
    `;
}

export function catalogQuotaRuleModelToXML(model: ModeleRegleAfpaQuota, isBenefits: boolean): string {
    return `
        <d4p1:ModeleRegle i:type="d4p1:ModeleRegleAFPAQuota${isBenefits ? 'Prestation' : ''}">
            ${getXmlLine(model, 'IdModeleRegle')}
            ${getXmlLine(model, 'IdRegle')}
            ${getXmlBoolean(model, 'IsRegleTransverse', {defaultValue: false})}
            ${getXmlLine(model, 'LibelleRegle', {defaultValue: ''})}
            ${getXmlLine(model, 'AgeMaximumEnfants')}
            ${getXmlLine(model, 'AgeMinimumEnfants')}
            ${getXmlBoolean(model, 'AllowForcage', {defaultValue: false})}
            ${getXmlLine(model, 'IdPeriode')}
            ${getXmlBoolean(model, 'IsEnfantsACharge', {defaultValue: false})}
            ${getXmlBoolean(model, 'IsEnfantsDirects', {defaultValue: false})}
            ${getXmlBoolean(model, 'IsEnfantsHandicapes', {defaultValue: false})}
            ${arrayNotEmpty(model.ListeValeurs?.anyType)
        ? `
                <d4p1:ListeValeurs
                    xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
                    xmlns:d10p2="http://schemas.datacontract.org/2004/07/V2DTO.Regle.Subvention">
                    ${beneficiariesCriteriasModelToXML(model.ListeValeurs.anyType)}
                </d4p1:ListeValeurs>`
        : ''}
            ${getXmlLine(model, 'NombreMaxArticle')}
            ${isBenefits
        ? `
                  ${getXmlLine(model, 'IdPeriodeDossier')}
                  ${getXmlLine(model, 'NombreDossierMaximum')}
                  ${getXmlLine(model, 'NombreUniteDossier')}
                `
        : `
                  ${getXmlBoolean(model, 'AllowSansSubvention', {defaultValue: false})}
                  ${getXmlLine(model, 'TypeValeur')}
              `}
        </d4p1:ModeleRegle>
    `;
}

export function beneficiaryTypeValueToXML(beneficiaryTypeValue: ValeurCriteresLimiteModelInput, beneficiaryType: string): string {
    return `
        <d9p1:anyType i:type="d10p2:ValeurCriteresLimiteModel">
            ${getXmlLine(beneficiaryTypeValue, 'BorneMaximum', {namespace: 'd10p2'})}
            ${getXmlLine(beneficiaryTypeValue, 'BorneMinimum', {namespace: 'd10p2'})}
            ${getXmlLine(beneficiaryTypeValue, 'IdBorne', {namespace: 'd10p2'})}
            ${getXmlLine(beneficiaryTypeValue, 'IdChampValeur', {namespace: 'd10p2'})}
            ${getXmlLine(beneficiaryTypeValue, 'IdModeleRegle', {namespace: 'd10p2'})}
            ${getXmlLine(beneficiaryTypeValue, 'IdValeur', {namespace: 'd10p2'})}
            ${getXmlLine(beneficiaryTypeValue, 'LibelleChamp', {namespace: 'd10p2'})}
            ${getXmlLine(beneficiaryTypeValue, 'Montant', {namespace: 'd10p2'})}
            <d10p2:TypeBeneficiaire>${beneficiaryType}</d10p2:TypeBeneficiaire>
            ${getXmlLine(beneficiaryTypeValue, 'ValeurMax', {namespace: 'd10p2'})}
            ${getXmlLine(beneficiaryTypeValue, 'ValeurMin', {namespace: 'd10p2'})}
        </d9p1:anyType>
    `;
}

export function catalogGiftToXML(giftParameters: CadeauAfpaModel): string {
    return `
<d4p1:Cadeau>
    ${getXmlLine(giftParameters, 'IdActivite')}
    ${getXmlLine(giftParameters, 'IdElement', {defaultValue: 0})}
    ${getXmlLine(giftParameters, 'IsModeAvance')}
    ${getXmlLine(giftParameters, 'IsPriceHidden')}
    ${arrayNotEmpty(giftParameters?.ListeCadeaux?.CadeauFPAModel) ? `
        <d4p1:ListeCadeaux>
        ${giftParameters.ListeCadeaux.CadeauFPAModel.map(gift => `
            <d4p1:CadeauFPAModel>
                ${getXmlLine(gift, 'IdCadeau')}
                ${getXmlLine(gift, 'AgeMax')}
                ${getXmlLine(gift, 'AgeMin')}
                ${getXmlLine(gift, 'AutoriseDepassementSubvention')}
                ${getXmlLine(gift, 'ChpListValId')}
                ${getXmlLine(gift, 'IdArticle')}
                ${getXmlLine(gift, 'ModeAvance')}
                ${getXmlLine(gift, 'Montant')}
                ${(gift as CadeauFpaModel)?.ModeAvance ? `
                    ${getXmlLine(gift, 'QuantiteMax')}
                    ${getXmlLine(gift, 'QuantiteMin')}
                    ` : ''
    }
                ${getXmlLine(gift, 'ToDelete')}
            </d4p1:CadeauFPAModel>
            `)?.join('') || ''}
        </d4p1:ListeCadeaux>
    ` : ''}
    ${getXmlBoolean(giftParameters, 'RedescendreParametrage', {defaultValue: false})}
</d4p1:Cadeau>
    `;
}

export function catalogBenefitsSettingsToXML(settings: ParametragePrestationModel): string {
    return `
<d4p1:ParametragePrestation>
    ${getXmlLine(settings, 'AnneeDebutRemboursement')}
    ${getXmlLine(settings, 'AnneeFinRemboursement')}
    ${getXmlLine(settings, 'IdElement', {defaultValue: 0})}
    ${(settings.IsCadeau && settings.IsCreditSurEnveloppeKalidea) ? getXmlLine(settings, 'IdEnveloppeKalidea') : ''}
    ${getXmlBoolean(settings, 'IsCadeau', {defaultValue: false})}
    <d4p1:IsCreditSurEnveloppeKalidea>${!!settings.IsCadeau && !!settings.IsCreditSurEnveloppeKalidea}</d4p1:IsCreditSurEnveloppeKalidea>
    ${getXmlBoolean(settings, 'IsPartACharge', {defaultValue: false})}
    ${getXmlBoolean(settings, 'IsRemboursement', {defaultValue: false})}
    ${getXmlBoolean(settings, 'IsRemboursementMensuel', {defaultValue: false})}
    <d4p1:IsSaisieChronologique>${!!settings.IsRemboursementMensuel && !!settings.IsSaisieChronologique}</d4p1:IsSaisieChronologique>
    <d4p1:IsSaisieObligatoireFournisseur>${settings.IsPartACharge || false}</d4p1:IsSaisieObligatoireFournisseur>
     ${arrayNotEmpty(settings.ListeIdFournisseursConventionnes?.decimal) && settings.IsPartACharge ? `
         <d4p1:ListeIdFournisseursConventionnes>
            ${settings.ListeIdFournisseursConventionnes?.decimal.map(id => `<d6p1:decimal>${id}</d6p1:decimal>`).join('')}
         </d4p1:ListeIdFournisseursConventionnes>
     ` : ''}
    ${getXmlLine(settings, 'MoisDebutRemboursement')}
    ${getXmlLine(settings, 'MoisFinRemboursement')}
    ${getXmlBoolean(settings, 'IsPartACharge', {defaultValue: false})}
    ${getXmlBoolean(settings, 'RedescendreParametrage')}
    ${settings.IsPartACharge ? getXmlLine(settings, 'TypeDocumentPresente') : ''}
</d4p1:ParametragePrestation>
    `;
}

export function catalogBenefitsRefundToXML(refund: PrestationRemboursementArticleModel): string {
    return `
<d4p1:ArticleRemboursementModel>
    ${getXmlBoolean(refund, 'IsProposerSaisieParticipants', {defaultValue: false})}
    ${refund?.ModeRemboursement === 'U' ? `
        ${getXmlLine(refund, 'LibelleUniteDecompte')}
        ${getXmlLine(refund, 'LibelleUnitePresentee')}
    ` : ''}
    ${getXmlLine(refund, 'ModeRemboursement', {defaultValue: 'F'})}
    ${getXmlLine(refund, 'PlafondMontantFacture')}
    ${refund?.ModeRemboursement === 'U' ? `
        ${getXmlLine(refund, 'Quotite')}
    ` : ''
    }
</d4p1:ArticleRemboursementModel>
    `;
}

export function catalogBenefitsVouchersToXML(arrayOfVouchers: ArrayOfPrestationPjArticleModel): string {
    return `
<d4p1:ListePieceJustificativeModel>
    ${arrayNotEmpty(arrayOfVouchers.PrestationPJArticleModel) ? arrayOfVouchers.PrestationPJArticleModel.map(voucher => `
        <d4p1:PrestationPJArticleModel>
            ${getXmlLine(voucher, 'IdPJ')}
            ${getXmlBoolean(voucher, 'IsObligatoire', {defaultValue: false})}
        </d4p1:PrestationPJArticleModel>
    `).join('') : ''
    }
</d4p1:ListePieceJustificativeModel>
    `;
}

export function catalogLoansVouchersToXML(arrayOfVouchers: ArrayOfLibTypePjBaseModel): string {
    return `
<d4p1:ListePieceJustificativeModel>
    ${arrayNotEmpty(arrayOfVouchers?.LibTypePJBaseModel) ? arrayOfVouchers.LibTypePJBaseModel.map(voucher => `
        <d4p1:LibTypePJBaseModel>
            ${getXmlLine(voucher, 'IdPJ')}
            ${getXmlBoolean(voucher, 'IsObligatoire', {defaultValue: false})}
        </d4p1:LibTypePJBaseModel>
    `).join('') : ''
    }
</d4p1:ListePieceJustificativeModel>
    `;
}

function catalogCancellationFeesToXML(cancellationFees: FraisAnnulationFpaModel): string {
    return `
<d4p1:FraisAnnulation>
    ${getXmlLine(cancellationFees, 'IdModeleFraisAnnulation')}
    ${getXmlLine(cancellationFees, 'RedescendreSurEnfants')}
    ${getXmlLine(cancellationFees, 'TypeElement')}
</d4p1:FraisAnnulation>
    `;
}

function catalogPaymentsToXML(payments: ModalitesReglementFpaModel): string {
    const schedulesList = payments?.ListeModeleEcheancier?.ModeleEcheancierGeneriqueModel || [];
    const paymentMethodsList = payments?.ListeMoyenPaiement?.MoyenPaiementAFPAModel || [];

    return `
<d4p1:ModalitesReglement>
    ${arrayNotEmpty(schedulesList) ? `
    <d4p1:ListeModeleEcheancier>
    ${schedulesList.map(schedule => `
        <d4p1:ModeleEcheancierGeneriqueModel>
            ${getXmlLine(schedule, 'IdElement', {defaultValue: 0})}
            ${getXmlLine(schedule, 'IdModeleEcheancier')}
             ${getXmlLine(schedule, 'IsDefaut')}
            ${getXmlLine(schedule, 'IsSelected')}
        </d4p1:ModeleEcheancierGeneriqueModel>
    `).join('\n')}
    </d4p1:ListeModeleEcheancier>
    ` : ''}
    ${arrayNotEmpty(paymentMethodsList) ? `
    <d4p1:ListeMoyenPaiement>
    ${paymentMethodsList.map(paymentMethod => `
        <d4p1:MoyenPaiementAFPAModel>
            ${getXmlLine(paymentMethod, 'IdElement', {defaultValue: 0})}
            ${getXmlLine(paymentMethod, 'IdMoyenPaiement')}
            ${getXmlBoolean(paymentMethod, 'IsDefaut')}
            ${getXmlBoolean(paymentMethod, 'IsEnLigne')}
        </d4p1:MoyenPaiementAFPAModel>
    `).join('\n')}
    </d4p1:ListeMoyenPaiement>
    ` : ''}
    ${getXmlLine(payments, 'RedescendreSurEnfants')}
</d4p1:ModalitesReglement>
    `;
}

function catalogDescriptionsToXML(arrayOfDescriptionBlocs: ArrayOfEditerBlocDescriptionModel): string {
    const descriptionBlocsList = arrayOfDescriptionBlocs?.EditerBlocDescriptionModel || [];

    return `
<d4p1:ListeBlocDescription>
    ${arrayNotEmpty(descriptionBlocsList) ? `
        ${descriptionBlocsList.map(descriptionBloc => `
    <d4p1:EditerBlocDescriptionModel>
        ${getXmlLine(descriptionBloc, 'Description')}
        ${getXmlLine(descriptionBloc, 'Id')}
        ${getXmlBoolean(descriptionBloc, 'IsDeleted', {defaultValue: false})}
        ${getXmlLine(descriptionBloc, 'Ordre', {defaultValue: 0})}
        ${getXmlLine(descriptionBloc, 'Titre')}
    </d4p1:EditerBlocDescriptionModel>
        `).join('\n')}
    ` : ''}
</d4p1:ListeBlocDescription>
    `;
}

function catalogDocumentsToXML(arrayOfDocuments: ArrayOfFichierModel): string {
    const documentsList = arrayOfDocuments?.FichierModel || [];
    return `
<d4p1:ListeDocuments>
    ${arrayNotEmpty(documentsList) ? `
        ${documentsList.map(document => `
    <d4p1:FichierModel>
        ${getXmlLine(document, 'Extension')}
        ${getXmlLine(document, 'FileBytes')}
        ${getXmlLine(document, 'Filename')}
        ${getXmlLine(document, 'IdFile')}
        ${getXmlLine(document, 'LibelleLien')}
        ${getXmlLine(document, 'RemarqueLien')}
        ${getXmlLine(document, 'Token')}
    </d4p1:FichierModel>
        `).join('\n')}
    ` : ''}
</d4p1:ListeDocuments>
    `;
}

function sharedResourceDescriptionToXML(description: RessourceDescriptionModel, name: string): string {
    return `
<d4p1:${name}>
    ${getXmlLine(description, 'DescriptionRessource')}
    ${arrayNotEmpty(description?.ListeImages?.FichierModel) ? `
    <d4p1:ListeImages>
        ${description.ListeImages.FichierModel.map(file => fileModelToXml(file, 'FichierModel')).join('\n\t\t')}
    </d4p1:ListeImages>
    ` : ''}
</d4p1:${name}>
    `;
}
